import { ISites } from '@df/core/df-core.interfaces';
import { NICmsContentComponent } from '@icms/core/content';

export namespace NMultisiteModal {
    /**
     * Component id and block url
     */
    export const componentId = 'multisite';

    /**
     * Modal block content
     */
    export interface IBlockContent extends NICmsContentComponent.IData {
        cmsCountryCode?: string;
        variants: IBlockContentVariant[];
    }

    export interface IBlockContentVariant {
        /**
         *  comma separated country codes
         */
        countries: string;
        /**
         *  default selected country id
         */
        defaultSiteId: string;
        /**
         * Top Heading
         */
        heading?: string;

        /**
         * Top copy
         */
        copy?: string;

        /**
         * Confirm button copy
         */
        buttonCopy: string;

        /**
         * Stores list
         */
        stores: IBlockContentStore[];
    }
    /**
     * Modal block content / store
     */
    export interface IBlockContentStore {
        // site id
        siteId: keyof ISites;
        // icon image
        icon?: string;
        //  name
        title: string;
        // subtitle
        subtitle?: string;
        // content HTML (wysywig)
        details?: string;
    }

    /**
     * Initiated data passed to modal
     */
    export interface IInitiatorData {
        matchingCountry: string; // customer geo if matched
    }
}
